import React, {Component} from 'react'
import Dropzone from 'react-dropzone'
import {ButtonGroup, FormControl, Button, Image} from 'react-bootstrap'


export default class ImageField extends Component {

	constructor(props) {
		super(props);

		this.onOpenClick = this.onOpenClick.bind(this);
		this.onCancelClick = this.onCancelClick.bind(this);
		this.onDrop = this.onDrop.bind(this);

		this.state = {files: []}
	}

	onDrop(filesToUpload) {
		this.setState({
			files: filesToUpload
		});

		this.props.input.onChange(filesToUpload)
	}

	onOpenClick() {
		this.refs.dropzone.open()
	}

	onCancelClick() {
		if (this.state.files) {
			for (let k in this.state.files) {
				if (this.state.files.hasOwnProperty(k)) {
					if (this.state.files[k].preview) {
						window.URL.revokeObjectURL(this.state.files[k].preview)
					}
				}
			}
		}
		this.setState({files: []});
		this.props.input.onChange({})
	}

	render() {

		const {
			buttonLabel,
			imgTitle,
			feedbackIcon,
			input,
			meta: {error, warning, touched},
			imgSrc
		} = this.props;

		let message;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>
		}

		const dzOptions = {
			multiple: false,
			accept: 'image/*',
			disablePreview: false
		};
		return (
			<div>
				<Image style={{maxHeight: "9.5em"}}
					title={this.state.files && this.state.files[0] ? imgTitle + ": " + this.state.files[0].name : ""}
					src={this.state.files && this.state.files[0] && this.state.files[0].preview ? this.state.files[0].preview : imgSrc} responsive thumbnail/>
				<Dropzone
					ref="dropzone"
					className="hidden"
					name={input.name}
					onDrop={this.onDrop}
					{...dzOptions}
				>
					{this.props.children}
				</Dropzone>
				{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
				{message}
				<ButtonGroup style={{margin: "15px 0"}}>
					<Button type="button" variant="info" onClick={this.onOpenClick}><span className="fa fa-open"/> {buttonLabel}</Button>
					{this.state.files && this.state.files[0]
					&& <Button type="button" variant="warning" onClick={this.onCancelClick} style={{padding: "6px 8px"}}><span className="fa fa-trash"/> </Button>}
				</ButtonGroup>
			</div>
		)
	}
}
